import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CourseService from "../../APIService/CourseService";
import TaskService from "../../APIService/TaskService";
import { CoursesNavigationButtons } from "../../components/task/CoursesNavigationButtons";
import TaskList from "../../components/task/TaskList";
import { CourseTypeEnum } from "../../enums";
import { useCourseContext } from "../../context/courseContext";
import useCourseNavigation from "../../shared/hooks/useCourseNavigation";
import Loading from "../../shared/loading";

export function CourseTaskPage(props: { courseType: CourseTypeEnum }) {
  const courseType = props.courseType;
  const {
    setCourse,
    course,
    setTaskList,
    taskList,
    setCourseIds,
    courseIds,
    isCheckButtonDisabled,
  } = useCourseContext();
  const params = useParams();
  const [isCoursesLoading, setIsCoursesLoading] = useState<boolean>(false);
  const { previousCourseId, nextCourseId } = useCourseNavigation(courseIds);
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.id) {
      setIsCoursesLoading(false);
      setTaskList([]);
      return;
    }

    const fetchCourse = async (id: string) => {
      setIsCoursesLoading(true);
      setTaskList([]);

      TaskService.getCourse(id, courseType)
        .then((response) => {
          setCourse(response.data.course);
          setIsCoursesLoading(false);
          setTaskList(response.data.tasks);
        })
        .catch((error) => {
          if (error.response.data.statusCode == 404) navigate("/404");
        });
    };

    fetchCourse(params.id);
  }, [params.id, setTaskList, setCourse, setIsCoursesLoading]);

  useEffect(() => {
    if (courseType === CourseTypeEnum.COURSE) {
      return;
    }

    const fetchCourseIds = async () => {
      const response = await CourseService.getAllCourseIds(courseType);
      setCourseIds(response.data);
    };

    fetchCourseIds();
  }, [courseType, setCourseIds]);

  return (
    <div className="Wrapper">
      {isCoursesLoading ? (
        <Loading />
      ) : (
        <TaskList tasks={taskList} course={course} />
      )}

      {isCheckButtonDisabled ? (
        <CoursesNavigationButtons
          previousCourseId={
            courseType !== CourseTypeEnum.COURSE ? previousCourseId : null
          }
          nextCourseId={
            courseType !== CourseTypeEnum.COURSE ? nextCourseId : null
          }
          courseType={courseType}
          currentCourseId={params.id}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
